export const ASSUMPTIONS = 'Assumptions';
export const OVERVIEW = 'Overview';
export const BENEFICIARIES = 'Beneficiaries';
export const CHECKLIST = 'Checklist';
export const ESTATE_FLOW = 'EstateFlow';
export const ASSUMPTIONS_TITLE = 'Below are the assumptions made for this plan';

export const GET_TITLE = selection => {
  if (selection === BENEFICIARIES) {
    return 'Beneficiary Review';
  }

  if (selection === ESTATE_FLOW) {
    return 'Estate Flow';
  }

  return selection;
};
